import React from 'react';
import Layout from '../../features/Layout';

import GreivanceRedressal from 'components/GreivanceRedressal';

const GrievanceRedressalPolicy = ({ isProd }) => {
  return (
    <Layout
      title="Khatabook - Our Apps"
      description="Digital India's Digital Khata! Download Khatabook now & take charge of all your transactions, use Khatabook and grow your business!"
      isProd={isProd}
    >
      <GreivanceRedressal />
    </Layout>
  );
};

export default GrievanceRedressalPolicy;
